/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeDialogContext,
  BaSeHeading6,
  BaSeLoading,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import * as React from 'react';
import {
  Container,
  ContainerButton,
  ContentButton,
  ContentInputs,
  Separator,
} from './chat-parameterization-style';

import { useMessage } from '../../../../hooks/messages/useMessage';
import { useChatService } from '../../../../hooks/services/chat-service';
const DEFAULT_PARAMETERS = {
  categoryValidaiton: {
    title: '',
    orientation: {
      header: '',
      firstOrientation: '',
      secondOrientation: '',
      thirdOrientation: '',
      fourthOrientation: '',
      fifthOrientation: '',
      footer: '',
    },
    command: '',
    output: '',
  },
  randomWordValidation: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  textExtrationRandomWords: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  validationEntrepreneurialBehavior: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  requestSupport: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  explainMore: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  messageSummary: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  defaultOrientation: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  defaultOutput: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  nextQuestion: {
    title: '',
    orientation: '',
    command: '',
    output: '',
  },
  numberExecutionExplainMore: {
    command: '',
  },
};
export const ChatParameterization = () => {
  const [parameters, setParameters] = React.useState(DEFAULT_PARAMETERS);
  const [loading, setLoading] = React.useState(false);
  const { getLastChatParameter, postSaveParameters, postRollbackParameters } =
    useChatService();
  const { showModal } = React.useContext(BaSeDialogContext);
  const { handleSuccess, handleAttention } = useMessage();

  React.useEffect(() => {
    setLoading(true);
    getLastChatParameter()
      .then((response) => {
        setParameters(response);
      })
      .finally(() => setLoading(false));
  }, [getLastChatParameter]);

  const openDialogConfirmSave = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Sim',
          type: 'primary',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        },
        {
          action: 'Não',
          type: 'secondary',
        },
      ],
      size: 'small',
      title: 'Confirmar inclusão',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <div style={{ gap: 12 }}>
          <BaSeHeading6
            color={BaSeTheme.colors.feedbackInterface.atencao55}
            isBold={true}
          >
            Atenção!
          </BaSeHeading6>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Tem certeza que deseja incluir os parâmetros da entrevista via chat?
          </BaSeParagraph>
        </div>
      ),
      onChooseAction: (action) => {
        if (action === 'Sim') {
          postSaveParameters(parameters)
            .then(() =>
              handleSuccess(
                'Parâmetros da entrevista via chat inseridos com sucesso!',
              ),
            )
            .catch((error) =>
              handleAttention(error.message ?? 'Erro ao salvar parametros!'),
            );
        }
        if (action === 'Não ') {
          getLastChatParameter().then((response) => {
            setParameters(response);
          });
        }
      },
    });
  }, [
    showModal,
    handleAttention,
    postSaveParameters,
    parameters,
    handleSuccess,
    getLastChatParameter,
  ]);

  const handleRollback = React.useCallback(() => {
    postRollbackParameters()
      .then((response) => {
        handleSuccess('Rollback realizado com sucesso!');
        setParameters(response);
      })
      .catch((error) => handleAttention(error.message));
  }, [handleAttention, handleSuccess, postRollbackParameters]);

  const openDialogConfirmRollback = React.useCallback(() => {
    return showModal({
      actions: [
        {
          action: 'Sim',
          type: 'primary',
          color: BaSeTheme.colors.institucionais.cinzaSebrae10,
        },
        {
          action: 'Não',
          type: 'secondary',
        },
      ],
      size: 'small',
      title: 'Confirmar rollback',
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      content: ({ closeModal, emitEvent }) => (
        <div style={{ gap: 12 }}>
          <BaSeHeading6
            color={BaSeTheme.colors.feedbackInterface.atencao55}
            isBold={true}
          >
            Atenção!
          </BaSeHeading6>

          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            Tem certeza que deseja realizar o "Rollback"?
          </BaSeParagraph>
        </div>
      ),
      onChooseAction: (action) => {
        if (action === 'Sim') {
          handleRollback();
        }
        if (action === 'Não') {
          getLastChatParameter().then((response) => {
            setParameters(response);
          });
        }
      },
    });
  }, [showModal, handleRollback, getLastChatParameter]);

  const handleSave = React.useCallback(() => {
    if (
      parameters.categoryValidaiton.command.trim() === '' ||
      parameters.categoryValidaiton.output.trim() === '' ||
      parameters.categoryValidaiton.orientation.header.trim() === '' ||
      parameters.categoryValidaiton.orientation.firstOrientation.trim() ===
        '' ||
      parameters.categoryValidaiton.orientation.secondOrientation.trim() ===
        '' ||
      parameters.categoryValidaiton.orientation.thirdOrientation.trim() ===
        '' ||
      parameters.categoryValidaiton.orientation.fourthOrientation.trim() ===
        '' ||
      parameters.categoryValidaiton.orientation.fifthOrientation.trim() ===
        '' ||
      parameters.randomWordValidation.orientation.trim() === '' ||
      parameters.randomWordValidation.command.trim() === '' ||
      parameters.textExtrationRandomWords.command.trim() === '' ||
      parameters.validationEntrepreneurialBehavior.orientation.trim() === '' ||
      parameters.validationEntrepreneurialBehavior.command.trim() === '' ||
      parameters.requestSupport.command.trim() === '' ||
      parameters.requestSupport.orientation.trim() === '' ||
      parameters.explainMore.command.trim() === '' ||
      parameters.messageSummary.command.trim() === '' ||
      parameters.messageSummary.orientation.trim() === '' ||
      parameters.defaultOrientation.orientation.trim() === '' ||
      parameters.defaultOutput.command.trim() === '' ||
      parameters.nextQuestion.output.trim() === '' ||
      parameters.numberExecutionExplainMore.command.trim() === ''
    ) {
      handleAttention('Campo obrigatório não informado!');
      return;
    }
    openDialogConfirmSave();
  }, [parameters, handleAttention, openDialogConfirmSave]);

  const returnTitleFormated = (text) => {
    return (
      <div>
        <BaSeSmall1 color={BaSeTheme.colors.defaultColors.black} isBold>
          {text}
        </BaSeSmall1>
        <Separator />
      </div>
    );
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BaSeLoading
          backgroundColor="#fff"
          description=""
          lightMode="default"
          shadowLevel={0}
          spinnerColor=""
          spinnerSize={24}
          text="Carregando…"
          textColor=""
        />
      </div>
    );
  }
  return (
    <Container>
      <div>
        {returnTitleFormated('Validação de categoria:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.categoryValidaiton.orientation.header}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.categoryValidaiton.orientation.header = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
            />
          </div>
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.firstOrientation}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.firstOrientation = value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.secondOrientation}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.secondOrientation =
                  value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.thirdOrientation}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.thirdOrientation = value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.fourthOrientation}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.fourthOrientation =
                  value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.fifthOrientation}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.fifthOrientation = value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />
          <BaSeTextArea
            value={parameters.categoryValidaiton.orientation.footer}
            onChange={(value) => {
              setParameters((prev) => {
                const newPrev = { ...prev };
                newPrev.categoryValidaiton.orientation.footer = value;
                return newPrev;
              });
            }}
            hasCounter={false}
          />

          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.categoryValidaiton.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.categoryValidaiton.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
          <div>
            <BaSeParagraph>Saída</BaSeParagraph>
            <BaSeTextArea
              value={parameters.categoryValidaiton.output}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.categoryValidaiton.output = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Validação de palavras aleatórias:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.randomWordValidation.orientation}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.randomWordValidation.orientation = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
            />
          </div>

          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.randomWordValidation.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.randomWordValidation.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Extração de texto nas palavras aleatórias:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.textExtrationRandomWords.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.textExtrationRandomWords.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Validação de comportamento empreendedor:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.validationEntrepreneurialBehavior.orientation}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.validationEntrepreneurialBehavior.orientation = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
            />
          </div>

          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.validationEntrepreneurialBehavior.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.validationEntrepreneurialBehavior.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Apoio na resposta:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.requestSupport.orientation}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.requestSupport.orientation = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
            />
          </div>

          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.requestSupport.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.requestSupport.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Explicar mais:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.explainMore.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.explainMore.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Resumo de mensagens:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.messageSummary.orientation}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.messageSummary.orientation = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
            />
          </div>

          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.messageSummary.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.messageSummary.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Orientação padrão:')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Orientações:</BaSeParagraph>
            <BaSeTextArea
              value={parameters.defaultOrientation.orientation}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.defaultOrientation.orientation = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={10}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Saída padrão (Booleano):')}
        <ContentInputs>
          <div>
            <BaSeParagraph>Comando</BaSeParagraph>
            <BaSeTextArea
              value={parameters.defaultOutput.command}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.defaultOutput.command = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      {/* -------------- */}
      <div>
        {returnTitleFormated('Próxima pergunta:')}
        <ContentInputs>
          <div>
            {/* <BaSeParagraph>Comando</BaSeParagraph> */}
            <BaSeTextArea
              value={parameters.nextQuestion.output}
              onChange={(value) => {
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.nextQuestion.output = value;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      <div>
        {returnTitleFormated('Quantidade de tentativas:')}
        <ContentInputs>
          <div>
            {/* <BaSeParagraph>Comando</BaSeParagraph> */}
            <BaSeTextArea
              value={parameters.numberExecutionExplainMore.command}
              onChange={(value) => {
                const numericValue = value.replace(/\D/g, '');
                setParameters((prev) => {
                  const newPrev = { ...prev };
                  newPrev.numberExecutionExplainMore.command = numericValue;
                  return newPrev;
                });
              }}
              hasCounter={false}
              rows={1}
            />
          </div>
        </ContentInputs>
      </div>

      <ContainerButton>
        <ContentButton>
          <BaSeButton
            value="Rollback"
            type="secondary"
            color="#54023b"
            onClick={() => openDialogConfirmRollback()}
          />
          <BaSeButton
            value="Salvar"
            onClick={() => handleSave()}
            color="#54023b"
          />
        </ContentButton>
      </ContainerButton>
    </Container>
  );
};
